import { getItem, setItem } from "../../utils/localStorage"
import { Params } from "react-router-dom"

export type UrlParams = {
  orgForm: string
  medMva: string
}

export const getParams = (): UrlParams | null => {
  const item = getItem("params") as UrlParams
  if (item !== undefined && item.medMva === "undefined") {
    storeParams({ ...item, medMva: "medMva" })
  }

  return getItem("params") as UrlParams
}
export const storeParams = (params: Params): void => setItem("params", params)
